import { Table } from "antd";
import PropTypes from "prop-types";

import { displayPromptResult } from "../../helpers/GetStaticData";

function TableView({ combinedOutput, isLoading }) {
  // Transform combinedOutput object into an array suitable for the Table component
  const dataSource = Object.keys(combinedOutput).map((key, index) => ({
    key: index + 1,
    field_name: key,
    ai_response: displayPromptResult(combinedOutput[key], true),
  }));

  const columns = [
    {
      title: "Field Name",
      dataIndex: "field_name",
      key: "field_name",
    },
    {
      title: "AI Response",
      dataIndex: "ai_response",
      key: "ai_response",
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={null}
      loading={isLoading}
    />
  );
}

TableView.propTypes = {
  combinedOutput: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export { TableView };
